// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"1aaae14a","233":"2d49e606","787":"a3893dd6","793":"4066ed82","896":"1ff81b1a"}[chunkId] + ".chunk.js";
};